import { Helmet } from 'react-helmet-async';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useCognitoCheckUser } from '@/entities/user/currentUser';

import { TITLE_META_TAG } from '@/shared/constants/titleMetaTag';
import { pickAttributionSearch } from '@/shared/lib/attribution';
import { Loader } from '@/shared/ui/Loader';

export const ProtectedRoute = () => {
  const location = useLocation();

  const { data, isPending: isUserAuthorizedChecking } = useCognitoCheckUser();
  const isAuthorized = data?.isAuthorized;

  if (isUserAuthorizedChecking) {
    return <Loader />;
  }

  if (isAuthorized) {
    return (
      <>
        <Helmet>
          <title>{TITLE_META_TAG}</title>
        </Helmet>
        <Outlet />
      </>
    );
  }

  return (
    <Navigate
      state={{ from: location }}
      to={{ pathname: '/auth', search: pickAttributionSearch(location.search) }}
      replace
    />
  );
};
